import service from "@irati/utils/tracking/index";
var TRACKING_ROOT = "user_onboarding_";
var UserOnboardingTracking = /** @class */ (function () {
    function UserOnboardingTracking() {
        this.welcomePopUpDismissed = function () {
            service.trackOnboardingEvent(TRACKING_ROOT + "welcome_popup_dismissed", {});
        };
        this.welcomePopUpGoToProfile = function () {
            service.trackOnboardingEvent(TRACKING_ROOT + "welcome_popup_go_to_profile", {});
        };
        this.bannerDismissed = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "banner_dismissed", params);
        };
        this.bannerButtonClicked = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "banner_button_clicked", params);
        };
        this.modalButtonClicked = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "modal_button_clicked", params);
        };
        this.modalLinkClicked = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "modal_link_clicked", params);
        };
        this.categorySelected = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "category_selected", params);
        };
        this.categoryDeselected = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "category_deselected", params);
        };
        this.categoriesSaved = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "categories_saved", params);
        };
        this.categoriesReset = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "categories_clearall", params);
        };
        this.categoryChangesAbandoned = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "category_changes_abandoned", params);
        };
        this.perksHomepageCategoryClicked = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "perks_homepage_category_clicked", params);
        };
        this.perksHomepageEditClicked = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "perks_homepage_edit_clicked", params);
        };
        this.perksHomepageSeeMoreClicked = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "perks_homepage_seemore_clicked", params);
        };
    }
    return UserOnboardingTracking;
}());
var userOnboardingTracking = new UserOnboardingTracking();
export default userOnboardingTracking;
